module.exports = __webpack_public_path__ + "img/strengthen.ee4cd62f.svg";